<template>
  <div :style="wrapStyle">
    <c-button @click="handleClickEvent()" ref="button"
              :class="deviceMode === 'pc' ? getCss('outer-pc') : getCss('outer-h5')"
              :style="computeouterStyle"
              v-bind="$props"></c-button>
    <!-- 领奖成功 -->
    <template>
      <c-base-dialog
        v-model="showVoteMode"
        :option="showVoteOption"
        @close="showVoteMode=false"
        @confirm="showVoteMode=false"
        @cancel="handlerReveiceClick"
        v-transfer-dom
      >
        <template slot="header">
          <h3 :class="getCss('vote-header')" :style="textColorStyle">
            {{ headerText }}
          </h3>
        </template>
        <template slot="body">
          <p :class="deviceMode === 'pc' ? getCss('reveice-dialog-content-pc') : getCss('reveice-dialog-content-h5')"
             :style="textColorStyle"
          >
            {{ voteText }}</p>
        </template>
        <template slot="footer">
        </template>
        <template slot="header" v-if="footText !== ''">
          <p :class="deviceMode === 'pc' ? getCss('reveice-dialog-footer-pc') : getCss('reveice-dialog-footer-h5')"
             :style="footFontSize">
            {{ footText }}</p>
        </template>
      </c-base-dialog>
    </template>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
import button from '@tencent/ceiba-act-public-button';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';

export default {
  name: 'CTgclubIssueCoupons',
  components: {
    [button.name]: button,
    [CDialog.name]: CDialog,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'tgclub-issue-coupons-',
      receiveStatus: 'reward', // 礼包是否可领取
      showVoteMode: false,
    };
  },
  computed: {
    wrapStyle() {
      return {
        top: this.styles.base.top,
        left: this.styles.base.left,
        width: this.styles.base.width,
        height: this.styles.base.height,
      };
    },
    footFontSize() {
      return {
        fontSize: `${this.configurationData?.footFontSize}px` || '15px',
      };
    },
    zIndex() {
      return this.configurationData.zIndex || '';
    },
    headerText() {
      return this.configurationData.headerText || '恭喜你获得';
    },
    voteText() {
      return this.configurationData.voteText || '优惠券领取成功';
    },
    footText() {
      return this.configurationData.footText || '';
    },
    enable() {
      console.log(this.quaInfo);
      console.log(this.configurationData.flowID);
      const packageStatus = this.quaInfo[this.configurationData.flowID];
      console.log('receiveStatus', packageStatus);
      if (!packageStatus) return true;
      return !(packageStatus.total > 0 && packageStatus.remain === 0);
    },
    backgroundImageMap() {
      return {
        reward: this.configurationData.backgroundReceiveBright || 'https://game.gtimg.cn/images/tgclub/act/a20220117test/03.png',
        rewarded: this.configurationData.backgroundReceiveGrey || 'https://game.gtimg.cn/images/tgclub/act/a20220117test/031.png',
      };
    },
    textColorStyle() {
      const color = this.dialogConfig?.dialogStyle?.color ?? '#ffffff';
      return { color };
    },
    computeouterStyle() {
      return {
        backgroundImage: `url(${this.backgroundImageMap[this.receiveStatus]})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
      };
    },
    showVoteOption() {
      console.log(this.dialogConfig.confirmStyle.backgroundImage);
      return Object.assign({}, this.dialogConfig, {
        header: true,
        footer: true,
        confirm: !!this.dialogConfig.confirmStyle?.backgroundImage,
        cancel: this.configurationData.cancel,
        close: true,
        controlClass: 'issue-coupons',
        closeLocation: this.deviceMode === 'pc' ? 'right-top' : 'top-right',
        height: this.deviceMode === 'pc' ? '300px' : '4.5rem',
        width: this.deviceMode === 'pc' ? '500px' : '7.2rem',
        confirmStyle: {
          'margin-bottom': this.deviceMode === 'pc' ? '100px' : '1rem',
          backgroundImage: this.dialogConfig.confirmStyle.backgroundImage || 'url(\'https://game.gtimg.cn/images/js/img/tgclub/a33ec1d1.png\'})',
        },
        cancelStyle: {
          'margin-bottom': this.deviceMode === 'pc' ? '100px' : '1rem',
          backgroundImage: `url(${this.configurationData.cancelStyle})`,
        },
      });
    },
  },
  async mounted() {
    console.log('receive-configurationData=', this.configurationData);
    console.log('this.isLogin', this.isLogin);
    await this.initialize();
  },
  methods: {
    async initialize() {
      this.$refs.button.setClickHandler(this.doReward, {
        forceApp: this.configurationData.forceApp,
        forceRole: this.configurationData.forceRole,
        forceLogin: true,
      });
      this.$onQuaRefreshed(async () => {
        console.log('this.isLogin', this.isLogin);
        if (this.enable) {
          this.receiveStatus = 'reward';
        } else {
          this.receiveStatus = 'rewarded';
        }
      });
    },
    // 执行领取
    async doReward() {
      if (this.configurationData.onlyNoApp && this.$ast.isAPP()) {
        this.alert(this.configurationData.errMsg);
        return;
      }
      console.log('this-isLogin', this.isLogin);
      if (!this.isLogin) {
        this.alert('请先登录');
        return;
      }
      if (this.receiveStatus == 'rewarded') return;
      const response = await this.flowRequest({
        flowId: this.configurationData.flowID,
        params: {
          role: this.roleInfo,
          data: JSON.stringify({ sType: `${this.zIndex}` }),
        },
      });
      this.refreshQua(); // 刷新礼包
      console.log('response-coupons', response);
      if (response.data.ret) {
        this.reportClickRaw({
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: 'reward_coupon',
          eventData: {
            status: '0',
          },
        });
        this.alert(response.data.msg || response.msg);
        return;
      }
      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'reward_coupon',
        eventData: {
          status: '1',
        },
      });
      this.showVoteMode = true;
    },
    // 跳转
    handlerReveiceClick() {
      this.showReveiceModal = false;
      const startTime = this.configurationData?.startTime || '';
      if (startTime && parseInt(this.nowTimeStr(), 10) < parseInt(this.getTime(startTime), 10)) ;
      {
        this.alert(this.configurationData.timeMsg);
        return;
      }
      window.location.href = this.configurationData.url;
    },
    getTime(str) {
      return new Date(str).getTime();
    },
    nowTimeStr() {
      return new Date().getTime();
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
